import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import { adminUserService } from '../../services';
import { signInRequest, updateAdminUser, 
  verifyTokenRequest, updateTrafficStatus, 
  updateTrafficStatusSpeech, updateTrafficStatusSuccess, updateTrafficStatusFailed,
} from '../../features/adminUserSlice';
import { baseUrl } from '../../config/baseUrl';
import NavigationService from '../../routers/NavigationService';
import { enqueueSnackbar } from '../../features/notificationSlice';

function* adminUserSignInSaga(action) {
  try {
    const adminUser = yield call(adminUserService.signIn, action.payload);
    yield put(updateAdminUser(adminUser.data));
    localStorage.setItem('token', adminUser.data.access_token);
    NavigationService.navigate(`${baseUrl}admin`);
    yield put(
      enqueueSnackbar({
        message: 'Login Success',
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (error) {
    yield put(
      enqueueSnackbar({
        message: 'Login Failed',
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

function* verifyTokenSaga() {
  try {
    yield call(adminUserService.verifyToken);
  } catch (error) {
    NavigationService.navigate(`${baseUrl}admin/sign-in`);
  }
}

function* updateTrafficStatusSaga(action) {
  try {
    yield call(adminUserService.updateTrafficStatus, action.payload);
    yield put(updateTrafficStatusSuccess());
    yield put(
      enqueueSnackbar({
        message: 'Update Traffic Status Successful',
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (error) {
    yield put(updateTrafficStatusFailed());
    yield put(
      enqueueSnackbar({
        message: 'Updated Failed',
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

function* updateTrafficStatusSpeechSaga(action) {
  try {
    console.log("Payload", ...action.payload);
    yield call(adminUserService.speechReport, action.payload);
    yield put(updateTrafficStatusSuccess());
    yield put(
      enqueueSnackbar({
        message: 'Update Traffic Status Successful',
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (error) {
    yield put(updateTrafficStatusFailed());
    yield put(
      enqueueSnackbar({
        message: 'Updated Failed',
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

export default function* adminUserSaga() {
  yield takeEvery(signInRequest, adminUserSignInSaga);
  yield takeEvery(verifyTokenRequest, verifyTokenSaga);
  yield takeEvery(updateTrafficStatus, updateTrafficStatusSaga);
  yield takeEvery(updateTrafficStatusSpeech, updateTrafficStatusSpeechSaga);
}